import axios from 'axios'

const client = axios.create({
    baseURL: '/api/Utils',
    json: true
})

export default {
    async execute(vue, method, resource, data) {
        return client({
            method,
            url: resource,
            data
        }).then(req => {
            if (req.data.error) {
                vue.$alert(req.data.error).then(() => {});
            }
            return req.data
        })
    },
    obtenerPublicKey(vue){
        return this.execute(vue, 'get', 'publickey')
    }
}
